import { Stack } from '@chakra-ui/react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { RichText } from '@/types/Product.types';
import RadioAsCheckboxGroup from '../RadioAsCheckboxGroup';

import { SWConfigureBundleOptionSecondaryOption } from '../SWConfigureBundleOptions.types';
import { checkboxGroupStyles } from './BundleSecondaryOption.styles';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip';
import { ITenantPortingTooltip } from '../CustomTooltip/TenantPortingTooltip';

interface IBundleSecondaryOption {
  tooltipText?: RichText;
  secondaryOptions: SWConfigureBundleOptionSecondaryOption[];
  selectedSecondaryOption: string;
  setSecondaryOption: (option: string) => void;
  tooltipExtraDetails?: Omit<ITenantPortingTooltip, 'tooltipText'>;
}

const BundleSecondaryOption = ({
  tooltipText,
  secondaryOptions,
  selectedSecondaryOption,
  setSecondaryOption,
  tooltipExtraDetails,
}: IBundleSecondaryOption) => {
  return (
    <RadioAsCheckboxGroup
      direction={{ base: 'column', sm: 'row' }}
      onChange={setSecondaryOption}
      value={selectedSecondaryOption}
      name="secondary-options"
      {...checkboxGroupStyles}
      options={secondaryOptions.map(option => ({
        name: option.name,
        value: `${option.id}-${option.contentful_id}`,
        children: (
          <Stack direction="row" spacing={{ base: 1, lg: 2 }}>
            {documentToReactComponents(JSON.parse(option.optionTitle.raw))}

            {tooltipText && <CustomTooltip tooltipText={tooltipText} tooltipExtraDetails={tooltipExtraDetails} />}
          </Stack>
        ),
      }))}
    />
  );
};

export default BundleSecondaryOption;
